'use client';
import React from 'react';
import { ContentSlider as SharedContentSlider } from '@launchstore/shared-puck';

export const ContentSlider: any = SharedContentSlider;
export default ContentSlider;
